<script setup>
import { HRow } from '@pixul/hephaestus';
</script>

<template>
  <HRow
    align-items='center'
    class='language-toggle'
    gap='14'
    @click='updateLanguage(otherLanguage)'
  >
    <AFlag
      :flag='otherLanguage'
      :size='16'
    />
    <p>{{ $t(`languages.${ otherLanguage }`) }}</p>
  </HRow>
</template>

<script>
import { mapStores }        from 'pinia';
import { useLanguageStore } from '@/store/language';

export default {
  name : 'LanguageToggle',

  data() {

    return {
      localLanguage : 'en'
    };
  },

  computed : {
    ...mapStores(useLanguageStore),

    otherLanguage() {

      return this.localLanguage === 'en' ? 'fr' : 'en';
    }
  },

  watch : {
    localLanguage() {

      this.languageStore.setLanguage(this.localLanguage);
    }
  },

  created() {

    this.localLanguage = this.languageStore.language;
  },

  methods : {
    updateLanguage(lang) {

      this.localLanguage = lang;
      document.body.click(); // Trigger close mobile menu
    }
  }
};
</script>

<style lang='scss' rel='stylesheet/scss' scoped>
.language-toggle {
  width: 100%;
}
</style>